import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
  CSpinner,
  CFormFeedback,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilEnvelopeOpen } from '@coreui/icons';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import httpClient from 'src/api/http-client';
import endpoints from 'src/api/endpoint';

const VerifyEmail = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: { email: '' },
    validationSchema: Yup.object({
      email: Yup.string().required('Email is required').email('Enter a valid email'),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      try {
        await httpClient.post(endpoints.auth.verifyEmail(), { email: values.email });
        toast.success('OTP sent to your email!');
        navigate('/verify-otp', { state: { email: values.email } });
      } catch (error) {
        error.response?.data?.message?.split(',').forEach((element) => {
          toast.error(element);
        });
      }
      setLoading(false);
    },
  });

  return (
    <div
      className="min-vh-100 d-flex flex-row align-items-center"
      style={{ background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)' }}
    >
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={7} lg={5}>
            <CCard
              className="border-0"
              style={{ borderRadius: '24px', boxShadow: '0 15px 35px rgba(0,0,0,0.08)' }}
            >
              <CCardBody className="p-5">
                <div className="d-flex justify-content-center mb-4">
                  <div
                    className="d-flex align-items-center justify-content-center rounded-circle bg-primary bg-opacity-10 text-primary"
                    style={{ width: '70px', height: '70px' }}
                  >
                    <CIcon icon={cilEnvelopeOpen} style={{ width: '32px', height: '32px' }} />
                  </div>
                </div>

                <div className="text-center mb-4">
                  <h3 className="fw-bold mb-2 text-dark">Forgot Password?</h3>
                  <p className="text-muted" style={{ fontSize: '0.95rem' }}>
                    Enter your email address to receive a secure OTP.
                  </p>
                </div>

                <CForm onSubmit={formik.handleSubmit}>
                  <CInputGroup
                    className="mb-4 shadow-sm"
                    style={{ borderRadius: '12px', overflow: 'hidden' }}
                  >
                    <CInputGroupText className="bg-white border-end-0 px-3">
                      <CIcon icon={cilEnvelopeOpen} className="text-muted" />
                    </CInputGroupText>
                    <CFormInput
                      type="email"
                      placeholder="Enter Email Address"
                      className="border-start-0 py-2 bg-white"
                      style={{ boxShadow: 'none' }}
                      invalid={!!(formik.touched.email && formik.errors.email)}
                      {...formik.getFieldProps('email')}
                    />
                    {!!(formik.touched.email && formik.errors.email) && (
                      <CFormFeedback invalid className="px-3 pb-2 bg-white">
                        {formik.errors.email}
                      </CFormFeedback>
                    )}
                  </CInputGroup>

                  <div className="d-grid gap-2 mt-2">
                    <CButton
                      color="primary"
                      type="submit"
                      disabled={loading}
                      className="py-2 text-white fw-semibold shadow-sm"
                      style={{ borderRadius: '12px', fontSize: '1.05rem' }}
                    >
                      {loading ? <CSpinner component="span" size="sm" className="me-2" /> : null}
                      Send OTP
                    </CButton>
                  </div>
                </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
      <ToastContainer position="top-right" autoClose={5000} />
    </div>
  );
};

export default VerifyEmail;
